/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:29b1d471-5fb8-4af0-9803-68c0200c7200",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_caNsDpOEU",
    "aws_user_pools_web_client_id": "4cvcg225l79mijra5tmfc07ss6",
    "oauth": {
        "domain": "tasksheetwebapplication-dev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://master.d1x8ia7b8zkxtw.amplifyapp.com/,https://www.dataterrainadmin.com/",
        "redirectSignOut": "http://localhost:3000/,https://master.d1x8ia7b8zkxtw.amplifyapp.com/,https://www.dataterrainadmin.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
